var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.showNewVersion
    ? _c("div", { staticClass: "fiscal-statistics-header" }, [
        _vm.permissions.invoicing_access
          ? _c(
              "dl",
              {
                staticClass:
                  "fiscal-statistics-header__set fiscal-statistics-header__turnover"
              },
              [
                _c(
                  "dt",
                  {
                    staticClass:
                      "fiscal-statistics-header__key typographies-paragraph-small-bold"
                  },
                  [
                    _vm._v(
                      "\n            " +
                        _vm._s(_vm.$l10n.__("Chiffre d'affaires total")) +
                        "\n        "
                    )
                  ]
                ),
                _vm._v(" "),
                _c(
                  "dd",
                  {
                    staticClass:
                      "fiscal-statistics-header__value typographies-paragraph-x-large-bold"
                  },
                  [
                    _vm.fiscal
                      ? [
                          _vm._v(
                            "\n                " +
                              _vm._s(_vm._f("numberformat")(_vm.fiscal.value)) +
                              "\n                " +
                              _vm._s(_vm.fiscal.unit ? _vm.fiscal.unit : "") +
                              "\n            "
                          )
                        ]
                      : [
                          _vm._v(
                            "\n                " +
                              _vm._s(_vm.$l10n.__("Calcul en cours")) +
                              "\n            "
                          )
                        ]
                  ],
                  2
                )
              ]
            )
          : _vm._e(),
        _vm._v(" "),
        _vm.latePayment && _vm.latePayment.value > 0
          ? _c(
              "dl",
              {
                staticClass:
                  "fiscal-statistics-header__set fiscal-statistics-header__late-payments"
              },
              [
                _c(
                  "dt",
                  {
                    staticClass:
                      "fiscal-statistics-header__key typographies-paragraph-small-bold"
                  },
                  [
                    _vm._v(
                      "\n            " +
                        _vm._s(_vm.$l10n.__("Règlements en retard")) +
                        "\n        "
                    )
                  ]
                ),
                _vm._v(" "),
                _c(
                  "dd",
                  {
                    staticClass:
                      "fiscal-statistics-header__value typographies-paragraph-x-large-bold"
                  },
                  [
                    _vm._v(
                      "\n            " +
                        _vm._s(
                          _vm.$options.filters.numberformat(
                            _vm.latePayment.value
                          )
                        ) +
                        "\n            " +
                        _vm._s(
                          _vm.latePayment.unit ? _vm.latePayment.unit : ""
                        ) +
                        "\n        "
                    )
                  ]
                )
              ]
            )
          : _vm._e()
      ])
    : _c("div", [
        _vm.permissions.invoicing_access
          ? _c("div", { staticClass: "mb-2" }, [
              _c("span", { staticClass: "grey fs-3 semibold" }, [
                _vm._v(_vm._s(_vm.$l10n.__("Chiffre d'affaires total")) + " : ")
              ]),
              _vm._v(" "),
              _vm.fiscal
                ? _c("span", { staticClass: "fs-5 bold" }, [
                    _vm._v(
                      _vm._s(
                        _vm.$options.filters.numberformat(_vm.fiscal.value)
                      ) +
                        "\n            " +
                        _vm._s(_vm.fiscal.unit ? _vm.fiscal.unit : "")
                    )
                  ])
                : _c("span", { staticClass: "fs-3 bold" }, [
                    _vm._v(_vm._s(_vm.$l10n.__("Calcul en cours")))
                  ])
            ])
          : _vm._e(),
        _vm._v(" "),
        _vm.latePayment && _vm.latePayment.value > 0
          ? _c("div", { staticClass: "fs-3 red semibold" }, [
              _c("span", [
                _vm._v(_vm._s(_vm.$l10n.__("Règlements en retard")) + " : ")
              ]),
              _vm._v(" "),
              _c("span", [
                _vm._v(
                  _vm._s(
                    _vm.$options.filters.numberformat(_vm.latePayment.value)
                  ) +
                    "\n            " +
                    _vm._s(_vm.latePayment.unit ? _vm.latePayment.unit : "")
                )
              ])
            ])
          : _vm._e()
      ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }